/*! hash:06b0d4e8a9e4ea1bc02d, chunkhash:bc2f5203ae1fc0e9711b, name:partner/index, filebase:index.bc2f5203a.js, query:, file:static/js/partner/index.bc2f5203a.js */
webpackJsonp([5],{

/***/ 14:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 30:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

__webpack_require__(1);

__webpack_require__(14);

__webpack_require__(2);

$(function () {
  wayPoint();
});

function wayPoint() {
  $('.page').waypoint(function (direction) {
    if (direction === 'down') {
      $(this.element).find('.state').addClass('animated slideInUp');
    }
  }, { offset: '70%' });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ })

},[30]);


// WEBPACK FOOTER //
// static/js/partner/index.bc2f5203a.js